module.exports = __webpack_public_path__ + "img/ski_cos1.980afa60.png";